import React from 'react'

function SvgDelete() {
  return (
    <svg
    width="88"
    height="88"
    viewBox="0 0 88 88"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="88"
      height="88"
      rx="14.6667"
      fill="#DD1E03"
      fillOpacity="0.1"
    />
    <path
      d="M44.4001 44.4001V34.5001M44.4001 51.7381V51.8251M64.2001 44.4001C64.2001 55.3353 55.3353 64.2001 44.4001 64.2001C33.4649 64.2001 24.6001 55.3353 24.6001 44.4001C24.6001 33.4649 33.4649 24.6001 44.4001 24.6001C55.3353 24.6001 64.2001 33.4649 64.2001 44.4001Z"
      stroke="#DD1E03"
      strokeWidth="4.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
  )
}

export default SvgDelete